export const isValidE164PhoneNumber = (value) => {
  return /^\+[1-9]\d{6,14}$/.test(String(value || '').trim());
};
